export const CapacityAnalysisDateType = {
    PLAN_DATE: 'planDate',
    PLAN_COMPARISON_DATE: 'planComparisonDate',
};
